import { render, staticRenderFns } from "./InfocardsList.vue?vue&type=template&id=4810baef&scoped=true&"
import script from "./InfocardsList.vue?vue&type=script&lang=js&"
export * from "./InfocardsList.vue?vue&type=script&lang=js&"
import style0 from "./InfocardsList.vue?vue&type=style&index=0&id=4810baef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4810baef",
  null
  
)

export default component.exports